
<template>
  <div class="login-layout">
    <div class="login-container">


      <!--LOGIN-->
      <Card class="login-card">

        <div align="center" class="mb-30">
          <img src="/static/img/logo.png" alt="" style="width: 115px">
        </div>


        <div v-if="!choiceUrl">
          <h1 class="login-header">Вход в систему</h1>
          <div style="min-height: 200px;">
            <Form
              ref="formData"
              :model="formData"
              :rules="rules"
              @keydown.enter.native="login()"
            >
              <FormItem prop="username">
                <Input
                  class="border_30"
                  type="text"
                  v-model="formData.username"
                  placeholder="Имя пользователя"
                  size="large"
                  v-mask="'+7(###) ###-##-##'"
                >
                </Input>
              </FormItem>
              <FormItem prop="password">

                <div class="pass-container">
                  <Input
                    class="border_30"
                    :type="pass_1"
                    v-model="formData.password"
                    placeholder="Пароль"
                    size="large"
                  >
                  </Input>
                  <span class="btn-show-pass" @click="changePassType()">
                    <Icon color="#acacac" v-if="pass_1 === 'password'" type="ios-eye" />
                    <Icon color="#acacac" v-if="pass_1 === 'text'" type="ios-eye-off" />
                  </span>
                </div>

              </FormItem>

              <div class="options-box">
                <router-link to="/login/reset" class="options-box__item" >Забыли пароль?</router-link>
                <router-link to="/login/register" class="options-box__item">Регистрация</router-link>
              </div>


                <Button
                  type="info"
                  @click="login()"
                  size="large"
                  :disabled="!validForm"
                >
                  Войти
                </Button>

              <Spin size="large" fix v-if="loading"></Spin>
            </Form>


          </div>
        </div>

        <div v-if="choiceUrl">
          <h1 class="login-header">Войти в систему</h1>

          <router-link to="/" class="enter-card">
            <Row class="d-flex align-center" gutter="24">
              <Col span="24" :sm="12"><h3>Панель администратора</h3></Col>
              <Col :sm="12">
                <img src="/static/img/enter_home.jpg" alt="">
              </Col>
            </Row>
          </router-link>
          <a :href="kassa_addr" class="enter-card">
            <Row class="d-flex align-center" gutter="24">
              <Col span="24" :sm="12"><h3>Касса</h3></Col>
              <Col :sm="12">
                <img src="/static/img/enter_kassa.jpg" alt="">
              </Col>
            </Row>
          </a>
        </div>


      </Card>


    </div>
  </div>
</template>

<script>

    import {server_addr, login_addr, kassa_addr } from "../../http";
    import {mask} from "vue-the-mask";
    import {formatErrorMsg} from "@/base/base_func.js";
    import register from '@/apps/login/register.vue'

    export default {
        name: "login",
        directives: {
            mask
        },
        components: {
            register
        },
        data() {

            return {

                validForm: false,
                validFormReset: false,
                validFormUpdate: false,

                pass_1: 'password',

                choiceUrl: false,
                formatNum: '',

                formData: {
                    username: "+7",
                    password: ""
                },

                formDataReset: {
                    phone: "+7"
                },
                formDataUpdate: {
                    password: '',
                    password_check: ''
                },
                enterCode: '',

                passwordReset__token: null,

                rules: {
                    username: [
                        {
                            required: true,
                            message: "Пожалуйста, введите имя пользователя",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 17,
                            message: "Недостаточно символов",
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: "Пожалуйста, введите имя пользователя",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 17,
                            message: "Недостаточно символов",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        {
                            required: true,
                            message: "Пожалуйста, введите пароль",
                            trigger: "change"
                        },
                        {
                            type: "string",
                            min: 4,
                            message: "Минимальная длина пароля - 4 символов",
                            trigger: "change"
                        }
                    ],

                },

                repeatCode: false,
                time: { m: 4, s: 59, ms: 0 },
                timeOn: true,
                count: null,

                loading: false
            };
        },
        watch: {
            "formData.username": function (val, oldVal) {
                // this.blockSubmit = !this.validForm();
                this.isValidForm();
            },
            "formData.password": function (val, oldVal) {
                this.isValidForm();
            }
        },

        computed: {
            kassa_addr() {
                return kassa_addr;
            },
            username() {
                return this.formData.username.replace(/^\+7/, "").replace(/\D/g, "");
            },
            password() {
                return this.formData.password;
            },
            handledData() {
                return {
                    username: this.username,
                    password: this.password,
                    grant_type: "password"
                };
            },

        },


        methods: {
            isValidForm() {
                this.$refs.formData.validate(valid => {
                    this.validForm = valid;
                });
            },


            login: function () {
                this.loading = true;
                this.$store
                    .dispatch("login", {vm: this, data: this.handledData})
                    .then(() => {
                        this.loading = false;
                        // this.$router.push({ name: "home" });
                        const url = server_addr + '/api/v1/current_user/';
                        this.$http
                            .get(url)
                            .then(result => {
                                let data = result.data;
                                if (data.role === 'cashier' ) {
                                    window.location.href = kassa_addr
                                }
                                if (data.role === 'storekeeper'  ) this.$router.push({ name: "home" });
                                if (data.role === 'owner'  ) this.choiceUrl = true;
                            });
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            // this.$Message.error("Неверное имя пользователя или пароль");
                            // this.$Message.error("Для работы с Товароучетной системой обратитесь в поддержку Light Kassa");
                          this.$Message.error("Проверьте корректность ввода логина или пароля. В случае повторной ошибки обратитесь в чат поддержки Light Kassa (правый нижний угол)");
                        } else {
                            this.$Message.error("Ошибка");
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },

            changePassType () {
                if(this.pass_1 === 'password') {
                    this.pass_1 = 'text'
                }

                else {
                    this.pass_1 = 'password'
                }
            }

        }
    };
</script>


<style scoped>
  .login-layout {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    background-color: #ebebeb;
  }

  .login-container {
    background: url("/static/img/bg-login.d56f2ef7.png") right center;
    background-size: cover;
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 15px;
    margin: 0;
    box-sizing: border-box;

  }

  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }

  .login-card {
    width: 600px;
    background: #fff;
    border-radius: 25px;
    position: relative;
    padding: 20px;
    margin-left: 10%;
  }

  .options-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .options-box .options-box__item {
    padding: 0 12px;
    color: #5087DE;
    text-decoration: underline;
    font-weight: 600;
  }

  .options-box .options-box__item:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  .options-box .options-box__item:nth-child(2) {
    border-left: 1px solid #5087DE;
  }

  .enter-card {
    border-radius: 25px;
    text-transform: uppercase;
    margin-bottom: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
    display: block;
    padding: 20px;
  }

  .enter-card:hover {
    background: #5087DE;
  }

  .enter-card:hover h3{
    color: #ffffff;
  }

  .enter-card img {
    max-width: 100%;
  }

  label.ivu-form-item-label, label {
    color: #acacac;
    font-size: 15px;
    margin-bottom: 5px;
    display: block;
  }

  input.ivu-input, textarea.ivu-input, .ivu-input-number {
    border-radius: 24px;
  }

  button {
    width: 100%;
    max-width: 300px;
    margin: 40px auto 24px auto;
    display: block;
    border-radius: 24px;
  }

  .timer-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    color: #acacac;
  }

  .timer-box button {
    width: auto;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 5px;
    color: #5087DE;
    text-decoration: underline;
    border-radius: 0;
  }

  .timer-box button[disabled="disabled"] {
    color: #acacac;
  }



  .pass-container {
    position: relative;
  }

  .pass-container .btn-show-pass {
    position: absolute;
    z-index: 5;
    right: 0;
    width: 48px;
    height: 100%;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pass-container .btn-show-pass:hover {
    cursor: pointer;
  }



  @media screen and (max-width: 767px) {
    .login-card {
      width: 90%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 400px) {
    .login-card {
      width: 95%;
      padding: 12px;
    }

  }

</style>

<style>
  .login-layout .ivu-input-group-prepend {
    background-color: transparent;
    border: none;
  }

  .login-layout .ivu-input-group-with-prepend .ivu-input {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }


  @media screen and (max-width: 400px) {

    .ivu-form-item-content .ivu-form-item-error-tip {
      font-size: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/login/login.vue